require('../css/main.scss');
require('../css/contact.scss');

const mobileMenu = require('./func/mobile-menu');

window.addEventListener('DOMContentLoaded', run);

async function run(e) {
    console.log('Contact page');
    mobileMenu('.c-mobile-menu', '.c-mobile-menu_button');

    document.querySelector('.c-form_submit').addEventListener('click', async e => {
        e.preventDefault();
        const classHidden = 't-display-none';
        const date = new Date();
        const form = document.querySelector('.c-form');
        const loader = document.querySelector('.c-form_loader');
        const submitButton = document.querySelector('.c-form_submit');
        const successMessage = document.querySelector('.c-form_message--success');
        const errorMessage = document.querySelector('.c-form_message--error');
        const data = {
            name: document.querySelector('input[name="name"]').value,
            surname: document.querySelector('input[name="surname"]').value,
            email: document.querySelector('input[name="email"]').value,
            phone: document.querySelector('input[name="phone"]').value,
            message: document.querySelector('textarea[name="message"]').value,
            secret: (
                new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate())).getTime() /
                1000
            ).toString(36)
        };

        let hasError = false;

        try {
            errorMessage.classList.add(classHidden);
            submitButton.classList.add(classHidden);
            loader.classList.remove(classHidden);

            const response = await fetch(process.env.ENDPOINT_CONTACT, {
                method: 'POST',
                body: JSON.stringify(data),
                headers: {
                    'Content-Type': 'application/json'
                }
            });

            const json = await response.json();

            if (json.data?.success) {
                form.style.display = 'none';

                successMessage.classList.remove(classHidden);
                successMessage.innerHTML = `
                <div class="c-form_message-title">Успешно Изпращане</div>
                <div class="c-form_message-content">
                    <p>Благодарим Ви, вашето съобщение беше прието успешно.</p>
                </div>`;
            } else {
                hasError = true;
            }
        } catch (error) {
            hasError = true;
        }

        loader.classList.add(classHidden);

        if (hasError) {
            submitButton.classList.remove(classHidden);
            errorMessage.classList.remove(classHidden);
            errorMessage.innerHTML = `
                    <div class="c-form_message-title">Възникнала Грешка</div>
                    <div class="c-form_message-content">
                        <p>
                            Възникнала е грешка при изпращането на съобщението Ви.
                            Съобщението не е изпратено, моля опитайте пак по-късно.
                        </p>
                    </div>`;
        }
    });
}
